import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DealPage } from "@/features/dealroom/DealPage";
import { DEAL_TABS } from "@/features/dealroom/route-params";

const search = z.object({
  tab: z.enum(DEAL_TABS).optional(),
});

export const Route = createFileRoute("/_app/deals/$deal")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { deal } = Route.useParams();
  return <DealPage id={deal} search={Route.useSearch()} />;
}
